import React, { useRef, useState, useEffect } from "react";
import "./HeroVideo.css";

const HeroVideo = () => {
  const videoRef = useRef(null);
  const [showPlayButton, setShowPlayButton] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    const promise = video.play();
    if (promise !== undefined) {
      promise.catch(() => setShowPlayButton(true));
    }
  }, []);

  const handlePlay = () => {
    const video = videoRef.current;
    if (!video) return;
    video.play();
    setShowPlayButton(false);
  };

  return (
    <section className="hero-video-section">
      <video
        ref={videoRef}
        className="hero-video-bg"
        muted
        loop
        playsInline
        preload="auto"
      >
        <source
          src="https://storage.googleapis.com/rasai-nutrie-assets/hero/hero-promo.mp4"
          type="video/mp4"
        />
      </video>

      <div className="hero-video-overlay"></div>

      {showPlayButton && (
        <button className="hero-play-btn" onClick={handlePlay} aria-label="Play video">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="48" height="48">
            <path d="M8 5v14l11-7z"/>
          </svg>
        </button>
      )}
    </section>
  );
};

export default HeroVideo;
